import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import Tooltip from "@shared/v2/Tooltip";
import { HeartSolidV6, MobileScreenSolidV6 } from "@shared/v2/Icomoon";
import { formatedPrice } from "../../../shared/ListingAlertHelpers";

const Properties = ({ stats }) => (
  <div className="tw-flex tw-flex-wrap tw-gap-[16px] tw-px-[8px] tw-pb-[16px]">
    {stats?.map(
      (
        {
          bathrooms,
          bedrooms,
          city,
          favorite,
          history_ext: historyExt,
          photo,
          price,
          state,
          street,
          url,
          zip,
          collection_names: collectionNames,
        },
        index,
      ) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className="tw-flex tw-flex-col tw-gap-[8px] tw-grow tw-w-[200px] tw-max-w-[214px] tw-shadow-card tw-rounded-[8px] tw-overflow-hidden"
        >
          <div className="tw-relative">
            <a
              href={url}
              target="_blank"
              style={{ backgroundImage: `url(${photo})` }}
              rel="noopener noreferrer"
              className="tw-block tw-bg-no-repeat tw-bg-cover tw-h-[132px] before:tw-content-[''] before:tw-block before:tw-absolute before:tw-inset-0 before:tw-bg-black before:tw-opacity-40"
            >
              <div className="tw-absolute tw-left-[10px] tw-bottom-[10px] tw-text-white tw-flex tw-flex-col">
                <div className="tw-text-16d tw-font-semibold">{formatedPrice(price)}</div>
                <div className="tw-text-14d tw-font-light">{street}</div>
                <div className="tw-text-14d tw-font-light">
                  {city}, {state} {zip}
                </div>
                <div className="tw-text-12d tw-font-bold">
                  {bedrooms} Bed | {bathrooms} Bath
                </div>
              </div>
            </a>
            {favorite && (
              <>
                <span className="tw-max-w-[170px] tw-text-14d tw-text-white tw-font-bold tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden tw-absolute tw-top-[7px] tw-right-[35px]">
                  {collectionNames?.[0] || ""}
                </span>

                <HeartSolidV6
                  className="tw-absolute tw-top-[10px] tw-right-[10px] tw-text-[#F2714D]"
                  size="l"
                />
              </>
            )}
          </div>
          <div className="tw-p-[8px] tw-flex tw-flex-col tw-gap-[8px] tw-overflow-x-hidden tw-overflow-y-auto tw-max-h-[66px]">
            <div className="tw-flex tw-justify-between tw-items-center tw-gap-[8px] tw-whitespace-nowrap">
              <div className="tw-text-11d tw-uppercase tw-font-bold">View History</div>
              <div className="tw-text-11d tw-uppercase tw-font-bold tw-bg-gray-5 tw-rounded-[12px] tw-py-[4px] tw-px-[10px]">
                Views: {historyExt.length}
              </div>
            </div>
            {historyExt.map((hist, i) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className="tw-text-12d"
              >
                <span className="tw-font-semibold">{dayjs(hist.viewed_at).format("MM/D/YYYY")}</span>
                <span> at {dayjs(hist.viewed_at).format("h:mm A")}</span>
                {hist.is_mobile && (
                  <div className="tw-float-right">
                    <Tooltip
                      trigger={<MobileScreenSolidV6 className="tw-align-middle" />}
                      content="Viewed from Brivity Home App"
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ),
    )}
  </div>
);

Properties.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape()),
};

Properties.defaultProps = {
  stats: [],
};

export default Properties;
